import React from 'react';
import Container from "react-bootstrap/Container";

export const InputContainer = ({children, classes = '', color = 'bg-light'}) => {
    return (
        <Container className={`${color} rounded pt-2 mb-3 ${classes}`}>
            {children}
        </Container>
    );
};